import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const APP_API_CONNECT = process.env.REACT_APP_API_CONNECT;

export const searchsApi = createApi({
  reducerPath: "searchsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${APP_API_CONNECT}/`,
  }),

  tagTypes: ["Search"],
  refetchOnMountOrArgChange: 1,
  keepUnusedDataFor: 86400000,
  endpoints: (builder) => ({
    getStoreSearchQuery: builder.query({
      query: (data) => {
        return {
          url: `api/store/${data.store_id}?page=${data.page}&size=${data.size}${data.nextCursor}${data.search_id}${data.searchCountry}${data.searchBrand}`,
          method: "GET",
          headers: {
            "X-Country-Code": data.countryCode,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 86400000,
      providesTags: ["Search"],
    }),

    getStoreQuerySearchQuery: builder.query({
      query: (data) => {
        return {
          url: `api/store/query/${data.query}?page=${data.page}&size=${data.size}${data.nextCursor}${data.search_id}${data.searchCountry}${data.searchBrand}`,
          method: "GET",
          headers: {
            "X-Country-Code": data.countryCode,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 86400000,
      providesTags: ["Search"],
    }),

    getStoreDeals: builder.query({
      query: (data) => {
        return {
          url: `api/products/warehouse/deals?page=${data.page}&size=${data.size}${data.nextCursor}${data.search}${data.search_id}${data.searchCountry}${data.searchBrand}`,
          method: "GET",
          headers: {
            "X-Country-Code": data.countryCode,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
      },
      // keepUnusedDataFor: 86400000,
      providesTags: ["Search"],
    }),
  }),
});

export const {
  useGetStoreSearchQueryQuery,
  useGetStoreQuerySearchQueryQuery,
  useGetStoreDealsQuery,
} = searchsApi;
